import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const MyAutocomplate = ({
  options = [],
  renderOption = (props, option) => {},
  value = null,
  getValue = (value) => {},
  label = "",
  getOptionLabel = (option) => option.name,
  required = false,
}) => {
  const [myValue, setMyValue] = useState(value);
  const [myOptions, setMyOptions] = useState(options);
  useEffect(() => {
    setMyOptions(options);
  }, [options]);
  return (
    <Autocomplete
      loading={myOptions.length === 0}
      options={myOptions}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      value={myValue}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(event, newValue) => {
        setMyValue(newValue);
        getValue(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size="small"
          required={required}
        />
      )}
    />
  );
};

export default MyAutocomplate;
